import ApplicationController from './application_controller';

// Connects to data-controller="message"
export default class extends ApplicationController {
  static targets = ['textarea', 'submit'];

  connect() {
    super.connect();

    this.toggleSubmit();
  }

  toggleSubmit() {
    const message = this.textareaTarget.value.trim();

    if (message.length > 0) {
      this.submitTarget.classList.remove('d-none');
    } else {
      this.submitTarget.classList.add('d-none');
    }
  }
}
